// Contact.jsx
import React from 'react';
import { Phone, Mail, MapPin, Clock, Instagram, Facebook, Youtube } from 'lucide-react';

const Contact = () => {
  const phoneNumber = '573184476101';
  const email = 'acsegcontraincendios@gmail.com';
  const address = 'Vía al Caimo Bambazu Casa 16';
  const whatsappMessage = encodeURIComponent(
    'Hola, Quisiera tener información acerca de ...'
  );

  const contactInfo = [
    {
      icon: Phone,
      title: 'WhatsApp',
      content: '318 447 6101',
      link: `https://wa.me/${phoneNumber}?text=${whatsappMessage}`
    },
    {
      icon: Mail,
      title: 'Email',
      content: email,
      link: `mailto:${email}`
    },
    {
      icon: MapPin,
      title: 'Dirección',
      content: address,
      link: 'https://www.google.com/maps/search/?api=1&query=V%C3%ADa+al+Caimo+Bambazu+Casa+16'
    },
    {
      icon: Clock,
      title: 'Horario',
      content: 'Lun - Vie: 8:00 - 18:00 | Llama ahora',
      link: `tel:+${phoneNumber}`
    }
  ];

  return (
    <section id="contacto" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <div className="inline-block mb-4">
            <span className="text-orange-600 font-semibold text-sm uppercase tracking-wider bg-orange-100 px-4 py-2 rounded-full">
              Contacto
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            ¿Listo para
            <span className="text-orange-600"> Proteger tu Espacio?</span>
          </h2>
          <p className="text-lg text-gray-600">
            Estamos aquí para ayudarte. Contáctanos y recibe una asesoría personalizada sin compromiso.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          <div className="lg:col-span-1 space-y-6">
            <div className="bg-gradient-to-br from-orange-600 to-orange-700 rounded-2xl p-8 text-white shadow-xl">
              <h3 className="text-2xl font-bold mb-6">Información de Contacto</h3>

              <div className="space-y-6">
                {contactInfo.map((item, index) => (
                  <a
                    key={index}
                    href={item.link}
                    target={item.title === 'WhatsApp' || item.title === 'Dirección' ? '_blank' : '_self'}
                    rel={item.title === 'WhatsApp' || item.title === 'Dirección' ? 'noopener noreferrer' : undefined}
                    className="flex items-start gap-4 hover:bg-white/10 p-3 rounded-lg transition-colors"
                  >
                    <div className="bg-white/20 p-3 rounded-lg flex-shrink-0">
                      <item.icon size={24} />
                    </div>
                    <div>
                      <h4 className="font-semibold mb-1">{item.title}</h4>
                      <p className="text-orange-100 text-sm">{item.content}</p>
                    </div>
                  </a>
                ))}
              </div>

              <div className="pt-6 mt-6 border-t border-white/20">
                <h4 className="font-semibold mb-4">Síguenos en redes</h4>
                <div className="flex gap-3">
                  <a
                    href="https://www.instagram.com/acsegcontraincendios?igsh=MWk3dGFyZm12MHd3ag=="
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                    className="bg-white/20 hover:bg-white/30 p-3 rounded-lg transition-colors"
                  >
                    <Instagram size={22} />
                  </a>

                  <a
                    href="https://www.facebook.com/share/14H6Gj7qXwe/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                    className="bg-white/20 hover:bg-white/30 p-3 rounded-lg transition-colors"
                  >
                    <Facebook size={22} />
                  </a>

                  <a
                    href="https://youtube.com/@acsegcontraincendios?si=BT9yI_0at-Y-e1ae"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="YouTube"
                    className="bg-white/20 hover:bg-white/30 p-3 rounded-lg transition-colors"
                  >
                    <Youtube size={22} />
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-red-50 border-2 border-red-200 rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="bg-red-600 p-2 rounded-lg">
                  <Phone className="text-white" size={20} />
                </div>
                <h3 className="font-bold text-red-900">Llama ahora</h3>
              </div>
              <p className="text-red-800 text-sm mb-4">
                ¿Necesitas asistencia inmediata? Llámanos ahora.
              </p>
              <a
                href={`tel:+${phoneNumber}`}
                className="block text-center bg-red-600 hover:bg-red-700 text-white font-bold py-3 rounded-lg transition-colors"
              >
                Llamar Ahora
              </a>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="rounded-2xl overflow-hidden h-full border border-gray-200 shadow-sm">
              <iframe
                title="Mapa ubicación ACSEG"
                src="https://www.google.com/maps?q=V%C3%ADa+al+Caimo+Bambazu+Casa+16&output=embed"
                className="w-full h-full min-h-[500px] block"
                loading="lazy"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;